module.exports = __webpack_public_path__ + "img/pb-sslogo02.c1549f27.svg";